class FeatureToken {
    constructor() {
        this.id = null;
        this.feature = null;
        this.isUnlimited = false;
        this.price = null;
        this.currentConsumption = 0;
        this.remaining = null;
    }
}

export { FeatureToken };
